"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const tecmaLogo_svg_1 = __importDefault(require("../../assets/common/tecmaLogo.svg"));
const errorPageDefaultProps = {
    classes: { logo: "", title: "", message: "", button: "" },
    logo: tecmaLogo_svg_1.default,
    fontFamily: "Segoe UI",
    title: "Qualcosa è andato storto",
    titleColor: "#4D4D4D",
    message: "Non siamo riusciti a trovare la pagina che cercavi oppure c’è stato un errore inaspettato.",
    messageColor: "#666666",
    buttonLabel: "Torna alla Homepage",
    buttonUrl: "/",
    buttonBackgroundColor: "#FFF",
    buttonLabelColor: "#4C4C4C",
    buttonBorderWidth: 1,
    buttonBorderColor: "#4D4D4D",
    onClick: () => {
        window.location.href = "/";
    },
};
exports.default = errorPageDefaultProps;
